"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var Entity_1 = require("./Entity");
var util_1 = require("./util");
var Field = /** @class */ (function () {
    /** Construct a field from a definition
     * @internal
     */
    function Field(_definition, _parent) {
        this._definition = _definition;
        this._parent = _parent;
    }
    Object.defineProperty(Field, "fieldNameSeparator", {
        /** The separator for nested field names */
        get: function () { return "."; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(Field, "entityFieldNameSeparator", {
        /** The separator between entity name and field name */
        get: function () { return "/"; },
        enumerable: false,
        configurable: true
    });
    ;
    /** Get a child field
     * @param name The child's name; can be a nested name using the separator
     * @returns The child field or null if not found
     */
    Field.prototype.field = function (name) {
        var _a;
        var _b = __read(Field.parseFieldName(name), 2), head = _b[0], tail = _b[1];
        if (head == null) {
            return this;
        }
        var fieldDef = (_a = this._definition.children) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.name === head; });
        return fieldDef != null ? new Field(fieldDef, this).field(tail) : null;
    };
    Object.defineProperty(Field.prototype, "fields", {
        /** Get an array of all child fields, or `null` if `this` is not a compound field */
        get: function () {
            var _this = this;
            if (this._definition.children == null) {
                return null;
            }
            return this._definition.children.map(function (fieldDef) { return new Field(fieldDef, _this); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "parent", {
        /** Get this field's parent */
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "root", {
        /** Get this field's root entity */
        get: function () {
            if (this.parent instanceof Entity_1.Entity) {
                return this.parent;
            }
            return this.parent.root;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "name", {
        /** Get the (local) name of this field */
        get: function () {
            return this._definition.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "fullName", {
        /** Get the full (nested) name of this field */
        get: function () {
            if (this._parent instanceof Entity_1.Entity) {
                return this._parent.name + Field.entityFieldNameSeparator + this.name;
            }
            return this._parent.fullName + Field.fieldNameSeparator + this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "type", {
        /** Get the type of this field */
        get: function () {
            return this._definition.type;
        },
        enumerable: false,
        configurable: true
    });
    /** Check if this field is a compound field */
    Field.prototype.isCompoundField = function () {
        return this._definition.children != null;
    };
    /** Get the effective (considering the parent field if exists) read permission for the highest role */
    Field.prototype.readPermission = function (roles, isOwner) {
        if (isOwner === void 0) { isOwner = false; }
        var myPermission = this.rawReadPermission(roles, isOwner);
        if (this._parent instanceof Entity_1.Entity) {
            return myPermission;
        }
        return myPermission && this._parent.readPermission(roles, isOwner);
    };
    /** Get the raw (not considering the parent field if exists) read permission for the highest role */
    Field.prototype.rawReadPermission = function (roles, isOwner) {
        if (isOwner === void 0) { isOwner = false; }
        if (this._definition.readPermission == null) {
            return false;
        }
        var roleValues = roles.map(util_1.toRoleValue).filter(util_1.isRoleValue);
        var highest = util_1.highestRoleValue(roleValues);
        if (highest == null) {
            return false;
        }
        return this._definition.readPermission[util_1.roleToRoleKey(highest, isOwner)];
    };
    /** Get the effective (considering a `NONE` obligation of the parent field if exists) write obligation for the highest role */
    Field.prototype.writeObligation = function (roles, isOwner) {
        if (isOwner === void 0) { isOwner = false; }
        var myObligation = this.rawWriteObligation(roles, isOwner);
        if (this._parent instanceof Entity_1.Entity) {
            return myObligation;
        }
        var parentObligation = this._parent.writeObligation(roles, isOwner);
        return parentObligation !== "NONE" ? myObligation : "NONE";
    };
    /** Get the raw (not considering the parent field if exists) write obligation for the highest role */
    Field.prototype.rawWriteObligation = function (roles, isOwner) {
        if (isOwner === void 0) { isOwner = false; }
        if (this._definition.writeObligation == null) {
            return "NONE";
        }
        var roleValues = roles.map(util_1.toRoleValue).filter(util_1.isRoleValue);
        var highest = util_1.highestRoleValue(roleValues);
        if (highest == null) {
            return "NONE";
        }
        var rolesKey = util_1.roleToRoleKey(highest, isOwner);
        var obligation = this._definition.writeObligation[rolesKey];
        // Wenn es keine Berechtigungen für owner gibt, die des für user verwenden
        if (rolesKey === 'owner' && obligation === 'NONE') {
            obligation = this._definition.writeObligation['user'];
        }
        if (!util_1.isWriteObligationValue(obligation)) {
            throw new TypeError("Illegal writeObligation value " + obligation + " ");
        }
        return obligation;
    };
    /** Check whether the highest role can read this field */
    Field.prototype.canRead = function (roles, isOwner) {
        if (isOwner === void 0) { isOwner = false; }
        return this.readPermission(roles, isOwner);
    };
    /** Check whether the highest role can write this field */
    Field.prototype.canWrite = function (roles, isOwner) {
        if (isOwner === void 0) { isOwner = false; }
        return this.writeObligation(roles, isOwner) !== "NONE";
    };
    /** Check whether the highest role must write this field */
    Field.prototype.mustWrite = function (roles, isOwner) {
        if (isOwner === void 0) { isOwner = false; }
        return this.writeObligation(roles, isOwner) === "MANDATORY";
    };
    /** Parse a possibly nested field name
     * @returns A tuple with head and tail
     * @internal
     */
    Field.parseFieldName = function (name) {
        if (name == null) {
            return [null, null];
        }
        var index = name.indexOf(Field.fieldNameSeparator);
        if (index === 0) {
            throw new Error("Illegal field name starting with " + Field.fieldNameSeparator);
        }
        else if (index + 1 === name.length) {
            throw new Error("Illegal field name ending with " + Field.fieldNameSeparator);
        }
        else if (index === -1) {
            // No separator or trailing separator: not a nested name
            return [name, null];
        }
        // Split the nested name into head and tail
        return [name.slice(0, index), name.slice(index + 1)];
    };
    return Field;
}());
exports.Field = Field;
